module.exports = __webpack_public_path__ + "media/images/liv__fantasy_logo-df70f9e48ecf8546c107c2050e488406.png";